import { inject, Injectable } from '@angular/core';

import { WINDOW } from '@pinup-teams/common';

import { AuthMethod } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  #window = inject(WINDOW);

  #authToken: string;
  #refreshToken: string;

  setAuthToken(method: AuthMethod, key: string): void {
    if (method === AuthMethod.TOKEN) {
      this.#authToken = key;
    } else {
      this.#authToken = window.localStorage.getItem(key) || '';
    }
  }

  getAuthToken(): string {
    return this.#authToken || '';
  }

  setRefreshToken(method: AuthMethod, key: string): void {
    if (method === AuthMethod.TOKEN) {
      this.#refreshToken = key;
    } else {
      this.#refreshToken = window.localStorage.getItem(key) || '';
    }
  }

  getRefreshToken(): string {
    return this.#refreshToken || '';
  }

  decodeJwt(idToken: string): Record<string, string | string[] | undefined> {
    const base64Url = idToken.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      this.#window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(jsonPayload);
  }
}
